export default (err, errMsg = null) => {
    if (!err.response) return toastr.error(err.message)

    const errorsList = {
        413: 'El contenido enviado es muy grande',
    }

    const data = errorsList[err.response.status] ?? err.response.data
    let errors = {}
    let message = ''
    if (typeof data === 'object') {
        errors = data.errors || []
        message = data.message
    }

    const messages = []
    // messages.push(err.message)
    !!errMsg && messages.push(errMsg)
    !!message && messages.push(message)
    if (typeof data === 'string') {
        messages.push(data)
    }
    Object.keys(errors).map(key => {
        const fieldErrors = errors[key]
        fieldErrors.map(errMsg => messages.push(errMsg))
    })

    // return toastr.error(messages.join('\n'))
    throw new Error(messages.join('\n'))
}
